import './RenderTitleCard.css';

export const RenderTitleCard = ({ backgroundImgUrl, title }: { backgroundImgUrl: string, title: string }) => {
  return (
    <div className="titleCardContent" style={{ backgroundImage: `url(${backgroundImgUrl})` }}>
      <p className="titleText" >{title}</p>
    </div>
  );
};